import { Container } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import GradientCircularProgress from "../../components/GradientCircularProgress/GradientCircularProgress";
import { postConsentRequest } from "../../api/ConsentApi";
import { ApiError } from "../../api/Api";
import { useLocation, useNavigate } from "react-router-dom";

const HomePage: React.FC = () => {
  
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const getSubdomain = (url: string) => url.replace(/^https?:\/\//, '').split('/')[0].split('.')[0] || null;

  const isValidString = (str: string | null) => {
    return str !== null && str !== undefined && str.trim() !== '';
  };
  
  

  const goToErrorPage = useCallback((errorMessage: string) => {
    navigate("/error?message=" + errorMessage);
  }, [navigate])

  const validateParams = useCallback((subdomain: string | null, ecreq: string | null, rid: string | null) => {
    let errorMessage = '';
  
    if (!isValidString(ecreq)) {
      errorMessage += 'ecreq cannot be empty. ';
    }
    if (!isValidString(rid)) {
      errorMessage += 'rid cannot be empty. ';
    }
    if (!isValidString(subdomain)) {
      errorMessage += 'subdomain cannot be empty. ';
    }
  
    if (errorMessage !== '') {
      goToErrorPage(errorMessage);
    }
  }, [goToErrorPage]);

  const fetchData = useCallback(async () => {
    const queryParams = new URLSearchParams(location.search);
    const ecreq = queryParams.get('ecreq');
    const rid = queryParams.get('rid');
    const subdomain = getSubdomain(window.location.href);

    validateParams(ecreq, rid, subdomain);

    const response = await postConsentRequest(subdomain!, ecreq!, rid!);
    
    if (response instanceof ApiError) {
      goToErrorPage(response.message);
    } else {
      window.location.href = response.body.url;
      return
    }
    setIsLoading(false);
  }, [goToErrorPage, validateParams, location.search])

  useEffect(() => {
    fetchData();
  }, [fetchData])

  return (
    <Container sx={{
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      {isLoading && <GradientCircularProgress />}
    </Container>
  );
};

export default HomePage;
